import {Bundle} from "components/Bundle";
import { DataChangedEventDetail } from "components/form/dataChangedEventDetail";
import { Form, FormDefinition } from "components/form/form";
import i18n from "components/i18n/i18n";
import {Renderer} from "components/Renderer";
import $ from "jquery";
import template from "./parametersDialog.hbs";
import "./parametersDialog.scss";

export class ParametersDialog {
    public definition: ParametersDialogDefinition;
    private dialog: JQuery;
    private form: Form;
    constructor(definition: ParametersDialogDefinition) {
        this.definition = definition;
        (this.definition.parametersForm?.definition as FormDefinition).preventLoss = false;
        this.definition.confirmationAcceptKey = this.definition.confirmationAcceptKey || "dialog.button.accept";
        this.definition.confirmationDeclineKey = this.definition.confirmationDeclineKey || "dialog.button.decline";
    }

    public open = () => {
        let buttons = [{
            id: "parameters-dialog-button-accept",
            text: i18n.instance.t(this.definition.confirmationAcceptKey),
            click: () => {
                this.definition.acceptCallback({ actionParameters: this.form.currentData });
                this.close();
            },
        },
        {
            id: "parameters-dialog-button-cancel",
            text: i18n.instance.t(this.definition.confirmationDeclineKey),
            click: () => {
                if (this.definition.cancelCallback != null) {
                    this.definition.acceptCallback({ actionParameters: this.form.currentData });
                }
                this.close();
            },
        }];

        const innerContainer = $(template(this.definition));

        let p = Renderer.instance().fullRender(this.definition.parametersForm, innerContainer[0]);
        p.then((f) => {
            this.dialog = innerContainer.dialog({
                title: i18n.instance.t(this.definition.confirmationTitleKey || "dialog.parameters.title"),
                resizable: false,
                height: "auto",
                modal: true,
                buttons,
                minHeight: 200,
                maxHeight: 1000,
                minWidth: 400,
                width: Math.min($(window).width() * .8, 900),
                maxWidth: 900,
                classes: {
                    "ui-dialog-content": "c-parameters-dialog__content",
                },
            });
            this.form = f as Form;
            if (!this.form.isValid()) {
                $("#parameters-dialog-button-accept").button("disable");
            }
            this.dialog[0].addEventListener("dataChanged", (e: CustomEvent<DataChangedEventDetail>) => {
                if (e.detail.isValid) {
                    $("#parameters-dialog-button-accept").button("enable");
                } else {
                    $("#parameters-dialog-button-accept").button("disable");
                }
            });
        });
    }

    public close = () => {
        this.dialog.dialog("close");
        this.dialog.dialog("destroy");
    }
}

export interface ParametersDialogDefinition {
    parametersForm: Bundle;
    confirmationTitleKey?: string;
    confirmationAcceptKey?: string;
    confirmationDeclineKey?: string;
    acceptCallback: (extraData: any) => void;
    cancelCallback?: () => void;
}
